import { useTranslation } from "react-i18next";
import { CloudinaryImage } from "shared/components";
import { getMultilingualString } from "shared/utils";
import { css } from "styled-system/css";
import { Flex } from "styled-system/jsx";
import { useBookerContext } from "widgets/booker/contexts";
import { autoGravity } from "@cloudinary/transformation-builder-sdk/qualifiers/gravity";
import { limitFill } from "@cloudinary/url-gen/actions/resize";
import { Button, Text } from "@ttc3k/trekker";
import { ContactUsPage } from "../OverlayPages";
import { useState } from "react";
import { ClosedSign } from "shared/components/atoms/icons/ClosedSign";

export const ClosedBookerPage = () => {
  const [contactUsOpen, setContactUsOpen] = useState(false);
  const { owner, booker, language, onCloseBookerModal } = useBookerContext();
  const { t } = useTranslation("booker", { keyPrefix: "CLOSED_BOOKER_PAGE" });
  return (
    <Flex
      px={"400"}
      py={"600"}
      flexDirection={"column"}
      gap={"400"}
      justifyContent={"space-between"}
      h={"full"}
      bg={"ink.100"}
    >
      {/* Header Logo */}
      <Flex
        h={"56px"}
        w={"100%"}
        alignItems={"center"}
        justifyContent={"center"}
      >
        {booker?.brandingLogo ? (
          <CloudinaryImage
            image={booker.brandingLogo}
            alt={getMultilingualString(owner?.name ?? {}, language)}
            imageStyleProps={{
              className: css({
                h: "56px",
                aspectRatio: "unset",
                objectFit: "contain",
                objectPosition: "center",
                margin: "0 auto",
              }),
            }}
            resize={limitFill().height(56).gravity(autoGravity())}
          />
        ) : (
          <Text
            color={"text.light"}
            visual={"smallSemiBold"}
            w={"full"}
            textAlign={"center"}
          >
            {getMultilingualString(owner?.name ?? {}, language)}
          </Text>
        )}
      </Flex>

      {/* Content */}
      <Flex flexDirection={"column"} gap={"400"} alignItems={"center"}>
        <ClosedSign w={"116px"} h={"85px"} transform={"rotate(-5deg)"} />
        <Text
          visual={"bodyMedium"}
          color={"text.mid"}
          w={"full"}
          textAlign={"center"}
        >
          {booker?.statusNotification &&
          getMultilingualString(booker.statusNotification, language).length > 0
            ? getMultilingualString(booker.statusNotification, language)
            : t("CONTENT", {
                ownerName: getMultilingualString(owner?.name ?? {}, language),
              })}
        </Text>
      </Flex>

      {/* Buttons */}
      <Flex gap={"150"} width={"full"}>
        <Button
          mode={"light"}
          size={"lg"}
          width={"full"}
          onClick={onCloseBookerModal}
          type="button"
        >
          {t("BACK_TO_SITE")}
        </Button>
        <Button
          mode={"light"}
          size={"lg"}
          width={"full"}
          onClick={() => setContactUsOpen(true)}
          type="button"
        >
          {t("CONTACT_US")}
        </Button>
      </Flex>

      <ContactUsPage
        open={contactUsOpen}
        onClose={() => setContactUsOpen(false)}
      />
    </Flex>
  );
};
